import React, { PureComponent } from 'react';
import { Popover } from 'antd';
import { PopoverProps } from 'antd/es/popover';

interface ClosablePopoverState {
    visible: boolean;
}

interface ClosablePopoverProps extends PopoverProps {
    autoHide?: boolean;
}

export class ClosablePopover extends PureComponent<ClosablePopoverProps, ClosablePopoverState> {
    // @ts-ignore
    private popOverRef = React.createRef<Popover>();
    private buttonWrapperRef = React.createRef<HTMLDivElement>();

    public static defaultProps: ClosablePopoverProps = {
        autoHide: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            if (this.props.autoHide) document.removeEventListener('click', this.handleClickOutside, { capture: true });
        });
    };
    show = () => {
        this.setState({ visible: true }, () => {
            if (this.props.autoHide) document.addEventListener('click', this.handleClickOutside, { capture: true });
        });
    };
    render() {
        //return original react component with additional props and wrap the children so it can track it on the click outside
        const { children, ...otherProps } = this.props;
        return (
            <Popover ref={this.popOverRef} {...otherProps} open={this.state.visible}>
                <div ref={this.buttonWrapperRef}>{children}</div>
            </Popover>
        );
    }

    isVisible() {
        return this.state.visible;
    }

    handleClickOutside = event => {
        if (!this.popOverRef?.current) return;

        if (
            !this.popOverRef?.current?.popupRef.current.getElement().contains(event.target) &&
            !this.buttonWrapperRef.current.contains(event.target)
        ) {
            this.hide();
        }
    };
}
